import * as React from 'react';
import Header from '../../containers/MenuManager/Header';
import { Api } from '../../typings/api';
import { PageWrapper, TitleWrapper } from './styles';
import Title from '../../containers/Title';
import PageBottomBar from './../../containers/Page/BottomBar';
import { DriveItemListOrigin } from '../../containers/DriveItemListPage/constants';
import SearchField from '../../containers/DriveItemList/Search/Field';
import { PageType } from '../../containers/Page/constants';

interface PageProps {
	children: React.ReactNode;
	hasBottomBar?: boolean;
	pageType?: PageType;
	title?: string;
	driveItems?: Api.DriveItem[];
	showSearchField: boolean;
	origin: string;
	originParam: string;
	isScrollable?: boolean;
}

const Page = ({
	children, driveItems, pageType, title, showSearchField,
	origin, originParam, hasBottomBar, isScrollable = true,
}: PageProps) => {
	const searchFieldElement = React.createRef<HTMLInputElement>();

	React.useEffect(() => {
		// to close keyboard on mobile devices after search results are displayed
		// (when search was made from other origin (e.g., folder))
		if (searchFieldElement.current) {
			searchFieldElement.current.blur();
		}
	}, [origin]);

	return (
		<>
			<Header driveItems={driveItems} />
			<PageWrapper pageType={pageType} isScrollable={isScrollable}>
				{showSearchField &&
					<SearchField
						innerRef={searchFieldElement}
						searchText={origin === DriveItemListOrigin.Search ? originParam : ''}
					/>
				}
				{title && !showSearchField &&
					<TitleWrapper>
						<Title title={title} />
					</TitleWrapper>
				}
				{children}
			</PageWrapper>
			{hasBottomBar &&
				<PageBottomBar selection={driveItems || []} />
			}
		</>
	);
};

export default Page;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Page/index.tsx